import { BaseStore } from 'fluxible/addons';

export default class FavoriteDesignerStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.isFavorite = false;
        this.isLoaded = false;
    }

    load({ isFavorite }) {
        this.isFavorite = isFavorite;
        this.isLoaded = true;
        this.emitChange();
    }

    setFavoriteOptimistically() {
        this.isFavorite = true;
        this.isLoaded = false;
        this.emitChange();
    }

    unsetFavoriteOptimistically() {
        this.isFavorite = false;
        this.isLoaded = false;
        this.emitChange();
    }

    setFavorite() {
        this.isFavorite = true;
        this.isLoaded = true;
        this.emitChange();
    }

    unsetFavorite() {
        this.isFavorite = false;
        this.isLoaded = true;
        this.emitChange();
    }
}

FavoriteDesignerStore.storeName = 'FavoriteDesignerStore';
FavoriteDesignerStore.handlers = {
    FAVORITE_DATA_LOADED: 'load',
    FAVORITE_FAIL: 'unsetFavorite',
    FAVORITE_START: 'setFavoriteOptimistically',
    FAVORITE_SUCCESS: 'setFavorite',
    UNFAVORITE_FAIL: 'setFavorite',
    UNFAVORITE_START: 'unsetFavoriteOptimistically',
    UNFAVORITE_SUCCESS: 'unsetFavorite',
};



// WEBPACK FOOTER //
// ./src/js/apps/favorite-designer/FavoriteDesignerStore.js